export default function CustomMarkPointStyleController() {
  // 设置默认停靠位置和偏移量
  this.defaultAnchor = BMAP_ANCHOR_TOP_LEFT;
  this.defaultOffset = new BMap.Size(10, 10);
}

CustomMarkPointStyleController.prototype = new window["BMap"].Control();

CustomMarkPointStyleController.prototype.initialize = function(map) {
  const control = document.createElement("div");
  control.classList.add("bmap-custom-marker-controller");
  const dot = document.createElement("div");
  const detail = document.createElement("div");
  dot.classList.add("bmap-custom-marker-control");
  detail.classList.add("bmap-custom-marker-control");

  dot.innerHTML = "仅显示点";
  detail.innerHTML = "显示名称";

  dot.onclick = (e) => {
    document.body.classList.add("_bmap_custom_marker_dot");
    document.body.classList.remove("_bmap_custom_marker_detail");
    dot.classList.add("bmap-custom-marker-control-active");
    detail.classList.remove("bmap-custom-marker-control-active");
  };
  detail.onclick = (e) => {
    document.body.classList.add("_bmap_custom_marker_detail");
    document.body.classList.remove("_bmap_custom_marker_dot");
    detail.classList.add("bmap-custom-marker-control-active");
    dot.classList.remove("bmap-custom-marker-control-active");
  };

  dot.click();

  control.appendChild(dot);
  control.appendChild(detail);
  map.getContainer().appendChild(control);
  return control;
};
